var DialogView = require('dialogview');
var Overlay = require('overlay');
var Connection = require('connection');


var LogDownloadDialogView = DialogView.extend({
    el: '#logDownloadContainer',
    initialize: function (options) {
        this.error = this.$('.userError');
        this.success = this.$('.userSuccess');
        this.tzSelect = this.$('select.tzSelect');
        this.buttons = this.$('.buttons');

        this.pendingHeader = this.$('.pendingHeader');
        this.pendingExports = this.$('.pendingExports');

        this.availHeader = this.$('.availHeader');
        this.availExports = this.$('.availExports');

        this.expiredHeader = this.$('.expiredHeader');
        this.expiredReveal = this.$('.expiredHeader a');
        this.expiredExports = this.$('.expiredExports');

        this.tz = this.$('.tz');

        this.init();
        this.afterHide = _.bind(this.init, this);

        DialogView.prototype.initialize.apply(this, arguments);
    },
    events: $.extend({}, DialogView.prototype.events, {
        'click a.tzChange': 'clickChange',
        'click .expiredHeader a': 'toggleExpired',
        'buttonClick .buttons button': 'clickButton'
    }),
    init: function () {
        this.error.hide();
        this.success.hide();
        this.tzSelect.empty().hide();

        this.pendingHeader.hide();
        this.availHeader.hide();
        this.expiredHeader.hide();
        this.expiredReveal.text('Show expired');
        this.$('.logExport span.explanation').timeago('dispose');
        this.pendingExports.empty().hide();
        this.availExports.empty().hide();
        this.expiredExports.empty().hide();
        this.buttons.find('button').prop('disabled', true).removeData('model');
        this.stopListening();
    },
    clickButton: function (e) {
        e.preventDefault();
        var button = $(e.target);
        var model = button.data('model');
        var options = {
            timezone: this.tzSelect.val(),
            model: model
        };
        button.addSpin();
        this.error.hide();
        this.model.exportLogs(options, _.bind(function (response) {
            button.removeSpin();
            if (response.success) {
                this.success.text('Your log export is in progress. We’ll email you when it’s ready.').fadeIn('fast');
                this.pendingHeader.show();
                var pending = this.renderPendingExport(response['export']);
                pending.highlightFlash();
                this.pendingExports.prepend(pending).show();
            } else {
                var msg;
                switch (response.message) {
                case 'invalid_cid':
                    msg = 'Invalid connection id';
                    break;
                case 'invalid_bid':
                    msg = 'Invalid buffer id';
                    break;
                case 'nothing_to_export':
                    msg = 'Nothing to export';
                    break;
                case 'rate_limited':
                    msg = 'You’re trying to export too quickly, try again later';
                    break;
                default:
                    msg = 'Error exporting logs';
                }
                this.error.text(msg).fadeIn('fast');
            }
        }, this));
    },
    clickChange: function (e) {
        e.preventDefault();
        this.tzSelect.toggle();
    },
    show: function (buffer) {
        this.renderButtons(buffer);
        this.listenTo(this.model, 'exportFinished', this.exportFinished);
        DialogView.prototype.show.call(this);
    },
    afterShow: function () {
        this.model.getExports(_.bind(function (response) {
            if (response.error || response.success === false) {
                this.error.text("Error fetching exports, try again later").fadeIn('fast');
            } else {
                this.renderTimezone(response);
                this.buttons.find('button').prop('disabled', false);
                this.buttons.find('button.buffer').focus();
                this.renderExports(response);
            }
        }, this));
    },
    renderExportTitle: function (exp) {
        var title = '';
        if (exp.cid) {
            var conn = this.model.getConnection(exp.cid);
            if (conn) {
                title += conn.getDisplayName();
                if (exp.bid) {
                    title += ': ';
                    var buf = conn.getBuffer(exp.bid);
                    if (buf) {
                        if (buf.isServerLog()) {
                            title += 'network console';
                        } else {
                            title += buf.getDisplayName();
                        }
                    } else {
                        title += 'unknown log (' + exp.cid + ')';
                    }
                }
            } else {
                title += 'Unknown network (' + exp.cid + ')';
                if (exp.bid) {
                    title += ': unknown log (' + exp.bid + ')';
                }
            }
        } else {
            title += 'All networks';
        }
        return title;
    },
    renderPendingExport: function (exp) {
        var start = new Date(this.model.backend.tsOffset(exp.startdate * 1000));
        var startStrings = $.extend({}, $.timeago.settings.strings, {
            prefixAgo: 'started',
            suffixFromNow: 'ago',
            prefixFromNow: 'started'
        });
        return $('<p class="logExport">')
            .attr('id', 'logExport_' + exp.id)
            .append($('<span>').text(this.renderExportTitle(exp)))
            .append(' ')
            .append($('<span class="explanation">')
                .attr('title', start.toISOString())
                .text(start.formatFullDate())
                .timeago('init', startStrings)
            );
    },
    renderAvailExport: function (exp) {
        var finish = new Date(this.model.backend.tsOffset(exp.finishdate * 1000));
        var expires = new Date(this.model.backend.tsOffset(exp.expirydate * 1000));
        var expiresStrings = $.extend({}, $.timeago.settings.strings, {
            prefixFromNow: 'expires in:',
            suffixFromNow: null,
            suffixAgo: null
        });
        var finishStrings = $.extend({}, $.timeago.settings.strings, {
            suffixFromNow: 'ago',
        });
        return $('<p class="logExport">')
            .attr('id', 'logExport_' + exp.id)
            .append($('<span class="timeago explanation">')
                .attr('title', expires.toISOString())
                .text(expires.formatFullDate())
                .timeago('init', expiresStrings)
            )
            .append(' ')
            .append($('<a>')
                .attr({
                    'href': exp.redirect_url,
                    'download': exp.file_name
                })
                .text(this.renderExportTitle(exp))
            )
            .append(' ')
            .append($('<span class="explanation">')
                .attr('title', finish.toISOString())
                .text(finish.formatFullDate())
                .timeago('init', finishStrings)
            );
    },
    renderExpiredExport: function (exp) {
        var finish = new Date(this.model.backend.tsOffset(exp.finishdate * 1000));
        var expires = new Date(this.model.backend.tsOffset(exp.expirydate * 1000));
        var expiredStrings = $.extend({}, $.timeago.settings.strings, {
            prefixAgo: 'expired:'
        });
        return $('<p class="logExport">')
            .attr('id', 'logExport_' + exp.id)
            .append($('<span class="timeago explanation">')
                .attr('title', expires.toISOString())
                .text(expires.formatFullDate())
                .timeago('init', expiredStrings)
            )
            .append(' ')
            .append($('<span>').text(this.renderExportTitle(exp)))
            .append(' ')
            .append($('<span class="explanation">')
                .attr('title', finish.toISOString())
                .text(finish.formatFullDate())
                .timeago()
            );
    },
    renderTimezone: function (response) {
        var tzDetect;
        _.each(response.timezones, function (tz) {
            var option = $('<option>').attr('value', tz.name).text(tz.abbrev + ' (' + tz.utc_offset + ') ' + tz.name);
            if (tz.name == response.timezone) {
                tzDetect = tz;
                option.prop('selected', true);
            }
            this.tzSelect.append(option);
        }, this);
        if (tzDetect) {
            this.tz.text(tzDetect.abbrev + ' (' + tzDetect.utc_offset + ') ' + tzDetect.name);
        }
    },
    renderExports: function (response) {
        if (response.inprogress.length) {
            this.pendingHeader.show();
            _.each(response.inprogress, _.bind(function (exp) {
                this.pendingExports.append(this.renderPendingExport(exp)).show();
            }, this));
        }
        if (response.available.length) {
            this.availHeader.show();
            _.each(response.available, _.bind(function (exp) {
                this.availExports.append(this.renderAvailExport(exp)).show();
            }, this));
        }
        if (response.expired.length) {
            _.each(response.expired, _.bind(function (exp) {
                this.expiredHeader.show();
                this.expiredExports.append(this.renderExpiredExport(exp));
            }, this));
        }
    },
    toggleExpired: function (e) {
        e.preventDefault();

        var scrollTo, action;
        var offset = this.expiredHeader.prop('offsetTop');
        if (this.expiredExports.is(':visible')) {
            this.expiredExports.slideUp('fast');
            scrollTo = (offset + this.expiredHeader.outerHeight(true)) - this.$el.height();
            action = 'Show';
        } else {
            this.expiredExports.show();
            scrollTo = Math.min(offset, this.el.scrollHeight - this.$el.height());
            action = 'Hide';
        }
        this.expiredReveal.text(action + ' expired');
        this.$el.animate({
            'scrollTop': scrollTo
        }, {
            duration: 'fast',
            queue: false
        });
    },
    renderButtons: function (buffer) {
        var connectionOnly = false;
        if (buffer) {
            var connection;
            if (buffer instanceof Connection) {
                connectionOnly = true;
                connection = buffer;
            } else {
                connection = buffer.connection;
            }
            // All buffers for the connection
            this.buttons.find('button.connection').data('model', connection);
            this.buttons.find('button.connection span').text('This network (' + connection.getDisplayName() + ')');

            if (!connectionOnly) {
                // Just the buffer
                var name;
                if (buffer.isServerLog()) {
                    name = 'This network console';
                } else if (buffer.isChannel()) {
                    name = 'This channel (' + buffer.getDisplayName() + ')';
                } else {
                    name = 'This conversation (' + buffer.getDisplayName() + ')';
                }
                this.buttons.find('button.buffer').data('model', buffer);
                this.buttons.find('button.buffer span').text(name);
            }
        }
        
        var allOnly = !buffer;
        this.$('.logChooseExplain').toggle(!allOnly);
        this.buttons.find('button.connection').toggle(!allOnly);
        this.buttons.find('button.buffer').toggle(!allOnly && !connectionOnly);
        this.buttons.find('button.all').toggle(!allOnly);
        this.buttons.find('button.all_only').toggle(allOnly);
    },
    exportFinished: function (message) {
        var exp = message['export'];
        this.pendingExports.find('#logExport_' + exp.id).remove();
        if (!this.pendingExports.find('p').length) {
            this.pendingHeader.hide();
            this.pendingExports.hide();
        }
        this.renderFinished(exp, this.success);
        this.availHeader.show();
        var avail = this.renderAvailExport(exp);
        avail.addClass('highlight');
        setTimeout(function () {
            avail.removeClass('highlight');
        }, 2000);
        this.availExports.prepend(avail).show();
    },
    renderFinished: function (exp, wrapper) {
        return wrapper
            .text('Your log export is ready. Download it: ')
            .append($('<a>').attr({
                'href': exp.redirect_url,
                'target': '_blank'
            }).text(this.renderExportTitle(exp)));
    },
    finishedOverlay: function (message) {
        var exp = message['export'];
        var msg = this.renderAvailExport(exp);
        msg.addClass('highlight');
        setTimeout(function () {
            msg.removeClass('highlight');
        }, 2000);
        var content = $('<p>').append(msg);
        var head = 'Log export ready';
        var overlay = new Overlay(content, {
            doneText: 'Close',
            head: head,
            message: message
        });
        return overlay;
    }
});


module.exports = LogDownloadDialogView;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/logdownloaddialogview.js
// module id = a/KD
// module chunks = 1